module.exports = __webpack_public_path__ + "img/logo.39c6e8ea.png";